import { useQuery } from "react-query";
import servicesUtils from "../../../utils/servicesUtils";
var useGetPatientReminders = function useGetPatientReminders(patientUid) {
  return useQuery(["patient-reminders", patientUid], function () {
    return servicesUtils.getService("/patients/".concat(patientUid, "/reminder/list/"));
  }, {
    enabled: !!patientUid
  });
};
export default useGetPatientReminders;